import { SipRecommendationActionType } from '../../api/common.types'
import type { SipPlanRecommendationContainerInput } from '../open/planRecommendationOpen'
import { useSipPlanRecommendation } from '../useSipPlanRecommendation'
import { SipStartPlanRecommendationSheet } from './SipStartPlanRecommendationSheet'

export function SipStartPlanRecommendationContainer(input: SipPlanRecommendationContainerInput) {
  const { onDismiss, isin, totalIdealSipAmount, recommendation, initiateSipCta } = input
  const { planDetails, isLoading, isFetchFailed, onRetry } = useSipPlanRecommendation(
    isin,
    SipRecommendationActionType.START,
    totalIdealSipAmount,
    true
  )

  return (
    <SipStartPlanRecommendationSheet
      onDismiss={onDismiss}
      planDetails={planDetails}
      isLoading={isLoading}
      isFetchFailed={isFetchFailed}
      onRetry={onRetry}
      recommendation={recommendation}
      initiateSipCta={initiateSipCta}
    />
  )
}
